const separateShippingToggle = document.querySelector('.js-separate-shipping-toggle')
const separateShippingFields = document.querySelector('.js-separate-shipping-fields')

if (separateShippingToggle && separateShippingFields) {
  const updateSeparateShippingVisibility = () => {
    separateShippingFields.hidden = !separateShippingToggle.checked
    separateShippingToggle.setAttribute(
      'aria-expanded',
      separateShippingToggle.checked.toString()
    )
  }

  updateSeparateShippingVisibility()
  separateShippingToggle.addEventListener('change', updateSeparateShippingVisibility)

  separateShippingToggle.form?.addEventListener('submit', () => {
    if (separateShippingToggle.checked) return

    separateShippingFields.querySelectorAll('input, select').forEach((field) => {
      field.value = ''
    })
  })
}
